// extracted by mini-css-extract-plugin
export default {"root":"WobrSSfcXo","root_assumeNoContentPadding":"fFiTx0Lx8E"};